import { useId, type ReactNode } from 'react';
import { Text } from '@backstage/ui';

/**
 * The right-hand panel of the creation form (« Votre projet ») and of the
 * « Configuration » tab (quota, changes, actions), mockups « F1 » and « U1 »
 * (2026-10-16): one card, its head (what the panel is about), then sections
 * under small-caps titles, a hairline between them. Sticky beside the form
 * once the layout has three columns (`Workbench`), under it otherwise.
 */
export function SidePanel(props: {
  /** The landmark's name. */
  label: string;
  head?: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  return (
    <aside
      className={['waadoo-side-panel', props.className]
        .filter(Boolean)
        .join(' ')}
      aria-label={props.label}
    >
      {props.head && (
        <div className="waadoo-side-panel__head">{props.head}</div>
      )}
      {props.children}
    </aside>
  );
}

/** A section of `SidePanel`, under its small-caps title. */
export function SidePanelSection(props: {
  title: ReactNode;
  children: ReactNode;
}) {
  const titleId = useId();
  return (
    <section className="waadoo-side-panel__section" aria-labelledby={titleId}>
      <Text
        as="h4"
        variant="body-small"
        weight="bold"
        color="secondary"
        className="waadoo-side-panel__title"
        id={titleId}
      >
        {props.title}
      </Text>
      {props.children}
    </section>
  );
}
